<template>
  <div class="user_box">
    <userMenu v-show="showMenu" />
    <div class="user_con">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import userMenu from '@/components/userMenu.vue'
export default {
  data() {
    return {}
  },
  components: {
    userMenu,
  },
  computed: {
    showMenu() {
      let show = !this.$route.meta.hideMenu
      return show
    },
  },
  methods: {},
}
</script>
<style scoped>
.user_box {
  margin: 0 auto;
  width: 1400px;
  display: flex;
  padding-bottom: 40px;
}
.user_con {
  width: 1080px;
  flex: 1;
  /* float: right; */
  min-height: 100px;
  background: #fff;
  height: fit-content;
}
</style>
